function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { postUiPreferences } from "../actions";
export var UiPreferencesContext = /*#__PURE__*/React.createContext({});
export var UiPreferencesProvider = function UiPreferencesProvider(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var uiPreferencesCall = useSelector(function (state) {
    return state.apiCalls.postUiPreferences["undefined"];
  }) || {};
  var savedUiPreferences = useSelector(function (state) {
    return state.entities.uiPreferences.byUserId[authUserId];
  });
  var _useCookies = useCookies(["pref-ui"]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    removeCookie = _useCookies2[2];
  var _useState = useState(savedUiPreferences || cookies["pref-ui"] || {
      operationsFilterModel: {
        items: [{
          field: "state.name",
          operator: "isAnyOf",
          value: ["In Cart", "Pending", "Submitted", "Committed", "Rejected"],
          id: -1
        }]
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    uiPreferences = _useState2[0],
    setUiPreferences = _useState2[1];
  useEffect(function () {
    removeCookie("pref-ui");

    // Persist only essential UI preferences (theme) for users who are not logged in,
    // to avoid storing large preference data in cookies.
    var minimalUiPreferences = {
      theme: uiPreferences.theme
    };
    setCookie("pref-ui", minimalUiPreferences);
    if (savedUiPreferences && JSON.stringify(savedUiPreferences) !== JSON.stringify(uiPreferences)) {
      dispatch(postUiPreferences(uiPreferences));
    }
  }, [uiPreferences]);
  useEffect(function () {
    if (!savedUiPreferences) return;
    setUiPreferences(savedUiPreferences);
  }, [savedUiPreferences]);
  return /*#__PURE__*/React.createElement(UiPreferencesContext.Provider, {
    value: {
      uiPreferences: uiPreferences,
      setUiPreferences: setUiPreferences,
      loading: uiPreferencesCall.isFetching
    }
  }, children);
};
export var useUiPreferencesContext = function useUiPreferencesContext() {
  return useContext(UiPreferencesContext);
};